export const staticPagesTabHeaders = [
  { key: 'drag', label: '', sortable: false },
  { key: 'title', label: 'Title', sortable: true },
  { key: 'createdBy', label: 'Created by', sortable: false },
  { key: 'dateCreated', label: 'Date Created', sortable: true },
  { key: 'category', label: 'Category', sortable: false },
  { key: 'status', label: 'Status', sortable: false },
  { key: 'action', label: 'Action', sortable: false },
];
